//@ts-nocheck
// TO DO FIX TYPESCRIPT BUILD ERROR
import {
  faArrowLeft,
  faChevronDown,
  faRefresh,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Tabs from '@radix-ui/react-tabs'
import {
  TokenMedia,
  useAttributes,
  useBids,
  useCollections,
  useDynamicTokens,
  useListings,
  useTokenActivity,
  useUserTokens,
} from '@reservoir0x/reservoir-kit-ui'
import { paths } from '@reservoir0x/reservoir-sdk'
import { ActivityFilters } from 'components/token/ActivityFilters'
import { MobileActivityFilters } from 'components/common/MobileActivityFilters'
import { OfficialCollection } from 'components/common/OfficialCollection'
import Layout from 'components/Layout'
import {
  Anchor,
  Box,
  Button,
  Flex,
  Grid,
  Text,
  FormatCryptoCurrency,
} from 'components/primitives'
import { Dropdown } from 'components/primitives/Dropdown'
import { TabsContent, TabsList, TabsTrigger } from 'components/primitives/Tab'
import FullscreenMedia from 'components/token/FullscreenMedia'
import { PriceData } from 'components/token/PriceData'
import { TokenActions } from 'components/token/TokenActions'
import { TokenActivityTable } from 'components/token/ActivityTable'
import { TokenInfo } from 'components/token/TokenInfo'
import { ToastContext } from 'context/ToastContextProvider'
import { useENSResolver, useMounted } from 'hooks'
import { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { NORMALIZE_ROYALTIES } from 'pages/_app'
import { useContext, useEffect, useState } from 'react'
import { jsNumberForAddress } from 'react-jazzicon'
import Jazzicon from 'react-jazzicon/dist/Jazzicon'
import { useMediaQuery } from 'react-responsive'
import supportedChains, { DefaultChain } from 'utils/chains'
import fetcher from 'utils/fetcher'
import { DATE_REGEX, timeTill } from 'utils/till'
import titleCase from 'utils/titleCase'
import { useAccount } from 'wagmi'
import { Head } from 'components/Head'
import { OffersTable } from 'components/token/OffersTable'
import { ListingsTable } from 'components/token/ListingsTable'
import { LoreTab } from 'components/lore/LoreTab'
import { DownloadAssetButton } from 'components/token/DownloadAssetButton'
import { getContractDefinition } from 'utils/collections'
import { SocialLinks } from 'components/token/SocialLinks'
import Image from 'next/image'
import { getImageSourceFromLabel } from 'utils/iconutils'

type Props = InferGetServerSidePropsType<typeof getServerSideProps>

type ActivityTypes = Exclude<
  NonNullable<
    NonNullable<
      Exclude<Parameters<typeof useTokenActivity>['1'], boolean>
    >['types']
  >,
  string
>

const IndexPage: NextPage<Props> = ({ assetId, ssr }) => {
  const assetIdPieces = assetId ? assetId.toString().split(':') : []
  let collectionId = assetIdPieces[0]
  const id = assetIdPieces[1]
  const router = useRouter()
  const { addToast } = useContext(ToastContext)
  const account = useAccount()
  const isMounted = useMounted()
  const isSmallDevice = useMediaQuery({ maxWidth: 900 }) && isMounted
  const [tabValue, setTabValue] = useState('lore')
  const [isRefreshing, setIsRefreshing] = useState(false)

  const [activityFiltersOpen, setActivityFiltersOpen] = useState(true)
  const [activityTypes, setActivityTypes] = useState<ActivityTypes>([])
  const [activityNames, setActivityNames] = useState<string[]>([])

  const contract = collectionId ? collectionId?.split(':')[0] : undefined

  console.log({ contract })
  console.log({ collectionId })
  console.log({ assetId })

  const { isPixelated, getUrlForBuy } = getContractDefinition(collectionId)

  const urlForBuy = getUrlForBuy ? getUrlForBuy(id as string) : ''

  const { data: tokens, mutate } = useDynamicTokens(
    {
      tokens: [`${contract}:${id}`],
      includeAttributes: true,
      includeTopBid: true,
      includeQuantity: true,
    },
    {
      fallbackData: [ssr.tokens ? ssr.tokens : {}],
    }
  )

  const token = tokens && tokens[0] ? tokens[0] : undefined
  const is1155 = token?.token?.kind === 'erc1155'
  const affinity = token?.token?.attributes?.find(
    (attr) => attr.key === 'Affinity'
  )?.value

  const { data: collections } = useCollections(
    {
      includeSecurityConfigs: true,
      includeMintStages: true,
      id: contract,
    },
    {
      fallbackData: [ssr.collection ? ssr.collection : {}],
    }
  )
  const collection = collections && collections[0] ? collections[0] : null

  const { data: userTokens } = useUserTokens(
    is1155 ? account.address : undefined,
    {
      tokens: [`${contract}:${id}`],
      limit: 20,
    }
  )

  const { data: offers } = useBids({
    token: `${contract}:${id}`,
    includeRawData: true,
    sortBy: 'price',
    limit: 1,
  })

  const { data: listings } = useListings({
    token: `${contract}:${id}`,
    includeRawData: true,
    sortBy: 'price',
    limit: 1,
  })

  const offer = offers && offers[0] ? offers[0] : undefined
  const listing = listings && listings[0] ? listings[0] : undefined

  const attributesData = useAttributes(collectionId)

  let countOwned = 0
  if (is1155) {
    countOwned = Number(userTokens?.[0]?.ownership?.tokenCount || 0)
  } else {
    countOwned =
      token?.token?.owner?.toLowerCase() === account?.address?.toLowerCase()
        ? 1
        : 0
  }

  const isOwner = countOwned > 0
  const owner = isOwner ? account?.address : token?.token?.owner
  const { displayName: ownerFormatted } = useENSResolver(token?.token?.owner)

  const tokenName = `${token?.token?.name || `#${token?.token?.tokenId}`}`

  const isBurned = token?.token?.owner === null

  const trigger = (
    <Button
      color="gray3"
      size="small"
      css={{
        justifyContent: 'space-between',
        width: '336px',
        px: '$2',
        py: '$2',
      }}
    >
      {isSmallDevice ? null : (
        <Text style="body1">
          {activityNames.map(titleCase).join(', ') || 'All Events'}
        </Text>
      )}
      <Text css={{ color: '$slate10' }}>
        <FontAwesomeIcon icon={faChevronDown} width={16} height={16} />
      </Text>
    </Button>
  )

  useEffect(() => {
    let tab = tabValue

    let deeplinkTab: string | null = null
    if (typeof window !== 'undefined') {
      const params = new URL(window.location.href).searchParams
      deeplinkTab = params.get('tab')
    }

    if (deeplinkTab) {
      switch (deeplinkTab) {
        case 'info':
          tab = 'info'
          break
        case 'activity':
          tab = 'activity'
          break
        case 'listings':
          tab = 'listings'
          break
        case 'offers':
          tab = 'offers'
          break
        case 'lore':
          tab = 'lore'
          break
      }
    }
    setTabValue(tab)
  }, [isSmallDevice])

  useEffect(() => {
    const updatedUrl = new URL(`${window.location.origin}${router.asPath}`)
    updatedUrl.searchParams.set('tab', tabValue)
    router.replace(updatedUrl, undefined, {
      shallow: true,
    })
  }, [tabValue])

  const pageTitle = token?.token?.name
    ? token.token.name
    : `${token?.token?.tokenId} - ${token?.token?.collection?.name}`

  const hasAffinityOrBio = (attributes: any) => {
    const relevantAttributes = ['Affinity', 'Title', 'Origin']
    return attributes?.some((attr: any) =>
      relevantAttributes.includes(attr.key)
    )
  }

  const showAffinityAndBio = hasAffinityOrBio(token?.token?.attributes)

  const hasAffinity = token?.token?.attributes?.some(
    (attr) => attr.key === 'Affinity'
  )
  const hasBio = token?.token?.attributes?.some((attr:any) =>
    ['Title', 'Name', 'Origin'].includes(attr.key)
  )
  const isTransmuted =
    token?.token?.collection?.id ===
    '0x251b5f14a825c537ff788604ea1b58e49b70726f'

  const handleRefreshToken = async () => {
    if (!token?.token?.contract || !token?.token?.tokenId) return

    setIsRefreshing(true)
    try {
      await fetch('https://api.reservoir.tools/tokens/refresh/v2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.NEXT_PUBLIC_RESERVOIR_API_KEY || '',
        },
        body: JSON.stringify({
          tokens: [`${token.token.contract}:${token.token.tokenId}`],
        }),
      })
      await mutate()
      addToast?.({
        title: 'Refresh token',
        description: 'Sucess. Check back in a few minutes.',
      })
    } catch (err) {
      console.error(err)
      addToast?.({
        title: 'Refresh token failed',
        description: 'Request to refresh this token failed. Please try again.',
      })
    } finally {
      setIsRefreshing(false)
    }
  }

  return (
    <Layout>
      <Head
        ogImage={token?.token?.image || collection?.banner}
        title={pageTitle}
        description={collection?.description as string}
      />

      <Flex
        justify="center"
        css={{
          maxWidth: 1000,

          mt: 10,
          pb: 60,
          marginLeft: 'auto',
          marginRight: 'auto',
          px: '$1',
          flexDirection: 'column',
          '@md': {
            mt: 48,
            px: '$3',
          },
        }}
      >
        {/* Section 1: Token Image and Data in row format */}
        <Flex
          css={{
            width: '100%',
            flexDirection: 'column',
            // space beween
            justifyContent: 'space-between',
            gap: 20,
            '@md': {
              flexDirection: 'row',
              gap: 40,
            },
          }}
        >
          {/* Token Image/iframe */}
          <Box
            css={{
              width: '100%',
              '@md': { width: '50%', minWidth: '300px' },
              borderRadius: 8,
              overflow: 'hidden',
            }}
          >
            {token?.token?.contract ===
              '0x521f9c7505005cfa19a8e5786a9c3c9c9f5e6f42' ||
            token?.token?.contract ===
              '0x251b5f14a825c537ff788604ea1b58e49b70726f' ? (
              <iframe
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                height="100%"
                sandbox="allow-scripts"
                src={token.token.metadata?.['mediaOriginal'] as string}
                style={{ minHeight: '445px', width: '100%', height: 'auto' }}
              ></iframe>
            ) : (
              <TokenMedia
                token={token?.token}
                videoOptions={{ autoPlay: true, muted: true }}
                imageResolution={'large'}
                style={{
                  width: '100%',
                  height: 'auto',
                  minHeight: isMounted && isSmallDevice ? 300 : 445,
                  borderRadius: 8,
                  overflow: 'hidden',
                  imageRendering: isPixelated ? 'pixelated' : 'auto',
                }}
                onRefreshToken={() => {
                  mutate?.()
                  addToast?.({
                    title: 'Refresh token',
                    description: 'Request to refresh this token was accepted.',
                  })
                }}
              />
            )}
            {/* @ts-ignore */}
            <SocialLinks token={token} />
            <FullscreenMedia token={token} />
          </Box>

          {/* Token Data */}
          <Flex
            direction="column"
            css={{
              width: '100%',
              '@md': { width: '50%' },
              gap: '$4',
            }}
          >
            <Flex direction="column" css={{ gap: '$2' }}>
              <Flex align="center" css={{ gap: '$2' }} justify="between">
                <Flex>
                  <Link
                    href={`/${router.query.chain}/collection/${token?.token?.collection?.id}`}
                    legacyBehavior={true}
                  >
                    <Anchor
                      css={{ display: 'flex', alignItems: 'center', gap: '$2' }}
                    >
                      <FontAwesomeIcon icon={faArrowLeft} height={16} />
                      <Text style="subtitle1" ellipsify>
                        {token?.token?.collection?.name}
                      </Text>
                      <Box css={{ marginBottom: 3 }}>
                        <OfficialCollection collectionId={collectionId} />
                      </Box>
                    </Anchor>
                  </Link>
                </Flex>
                <Flex justify="between" align="center" css={{ gap: '$2' }}>
                  <Button
                    onClick={handleRefreshToken}
                    disabled={isRefreshing}
                    color="gray3"
                    size="xs"
                  >
                    <FontAwesomeIcon icon={faRefresh} width={16} height={16} />
                  </Button>
                  <DownloadAssetButton token={token} />
                </Flex>{' '}
              </Flex>
              <Text style="h4" css={{ wordBreak: 'break-all' }}>
                {tokenName}
              </Text>
              {isBurned && (
                <Text
                  style="subtitle2"
                  css={{
                    color: '$red11',
                    marginTop: '$1',
                  }}
                >
                  Burned
                </Text>
              )}
            </Flex>

            <Flex
              direction="row"
              css={{ gap: '$4' }}
              align="center"
              justify="between"
            >
              <Flex align="center" css={{ gap: '$2' }}>
                <Text style="subtitle3" color="subtle">
                  Owner
                </Text>
                <Jazzicon
                  diameter={16}
                  seed={jsNumberForAddress(owner || '')}
                />
                <Link href={`/portfolio/${owner}`} legacyBehavior={true}>
                  <Anchor
                    weight="normal"
                    font="ocrA"
                    color="primary"
                    css={{ fontSize: 12 }}
                  >
                    {isMounted ? ownerFormatted : ''}
                  </Anchor>
                </Link>
              </Flex>
            </Flex>

            {/* Single pixel divider */}
            <Box
              css={{
                height: 1,
                backgroundColor: '$gray8',
                margin: '$4 0',
              }}
            />

            <Flex direction="column" css={{ gap: '$4' }}>
              <PriceData token={token} />
              {isMounted && !urlForBuy ? (
                <TokenActions
                  token={token}
                  collection={collection}
                  offer={offer}
                  listing={listing}
                  isOwner={isOwner}
                  mutate={mutate}
                  account={account}
                />
              ) : (
                <a href={urlForBuy} target="_blank" style={{ flex: 1 }}>
                  <Button
                    color="secondary"
                    css={{
                      width: '100%',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                  >
                    {listing ? 'Buy Now' : 'Make Offer'}
                  </Button>
                </a>
              )}
            </Flex>
          </Flex>
        </Flex>

        {/* Section 2 */}
        <Flex
          css={{
            width: '100%',
            mt: '$2',
            gap: '$4',
            flexDirection: isSmallDevice ? 'column' : 'row',
          }}
        >
          {/* Left column: Traits */}
          <Box
            css={{
              flex: showAffinityAndBio ? '1 1 60%' : '1 1 100%',
            }}
          >
            <Box
              css={{
                textAlign: 'center',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '8px',
              }}
            >
              <Grid
                css={{
                  gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                  gap: '$3',
                  textAlign: 'start',
                  justifyContent: 'start',
                  flex: 1,
                }}
              >
                {token?.token?.attributes
                  ?.filter(
                    (attribute) =>
                      ![
                        '# Traits',
                        'Affinity',
                        '# Traits in Affinity',
                        '% Traits in Affinity',
                        'Origin',
                        'Title',
                        'Name',
                        'Affiliation',
                        'Transmuted from number',
                      ].includes(attribute.key)
                  )
                  .map((attribute) => {
                    const imageSource = getImageSourceFromLabel(
                      attribute,
                      token?.token?.contract,
                      attribute.key
                    )

                    const attributeFilterLink = `/ethereum/collection/${
                      token?.token?.contract
                    }?tab=items&attributes[${encodeURIComponent(
                      attribute.key
                    )}]=${encodeURIComponent(attribute.value)}`

                    console.log({ attribute })

                    return (
                      <Link
                        href={attributeFilterLink}
                        key={`${attribute.key}-${attribute.value}`}
                      >
                        <Box
                          key={`${attribute.key}-${attribute.value}`}
                          css={{
                            borderRadius: '$1',
                            padding: '$2',
                            border: '1px solid #3c3c3e',
                            display: 'flex',
                            flexDirection: 'column',
                            borderRadius: '8px',
                            height: '100%', // Ensure all boxes have the same height
                            justifyContent: 'space-between', // Distribute content evenly
                          }}
                        >
                          <Text
                            css={{
                              color: '#8e8e93',
                              fontSize: 12,
                              marginBottom: '$1',
                              fontFamily: '$body',
                            }}
                          >
                            {attribute.key.toUpperCase()}
                          </Text>

                          <Flex
                            css={{
                              justifyContent: 'space-between',
                              alignItems: 'end',
                            }}
                          >
                            <Flex css={{ alignItems: 'center', gap: '$2' }}>
                              {imageSource && (
                                <Image
                                  src={imageSource}
                                  width={24}
                                  height={24}
                                  alt={`${attribute.key} - ${attribute.value}`}
                                />
                              )}
                              <Text
                                css={{
                                  color: '#e0e0e0',
                                  fontWeight: 'bold',
                                  fontFamily: '$header',
                                }}
                              >
                                {attribute.value}
                              </Text>
                            </Flex>
                            <Flex
                              direction="column"
                              align="end"
                              css={{ gap: '$1' }}
                            >
                              <Text style="body3">
                                {attribute.tokenCount}
                                {' ('}
                                {(
                                  (attribute.tokenCount /
                                    collection.tokenCount) *
                                  100
                                ).toFixed(2)}
                                {'%)'}
                              </Text>
                              <FormatCryptoCurrency
                                amount={attribute.floorAskPrice}
                                decimals={
                                  collection?.floorAsk?.price?.currency
                                    ?.decimals
                                }
                                logoHeight={14}
                                textStyle="subtitle1mono"
                                maximumFractionDigits={3}
                              />
                            </Flex>
                          </Flex>
                        </Box>
                      </Link>
                    )
                  })}
              </Grid>
            </Box>
          </Box>

          {/* Right column: Affinity and Bio */}
          {(() => {
            const hasAffinityOrBio = token?.token?.attributes?.some(
              (attr) =>
                attr.key === 'Affinity' ||
                ['Title', 'Name', 'Origin'].includes(attr.key)
            )
            const isTransmuted =
              token?.token?.collection?.id ===
              '0x251b5f14a825c537ff788604ea1b58e49b70726f'

            // Only render if there's affinity, bio, or it's transmuted
            return (
              (hasAffinityOrBio || isTransmuted) && (
                <Box
                  css={{
                    flex: '1 1 40%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  {/* Affinity */}
                  {token?.token?.attributes?.some(
                    (attr) => attr.key === 'Affinity'
                  ) && (
                    <Box
                      css={{
                        borderRadius: '8px',
                        padding: '$4',
                        mb: '$4',
                        border: '1px solid #3c3c3e',
                        flex: '1',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Text
                        style="body3"
                        css={{
                          color: '#8e8e93',
                        }}
                      >
                        AFFINITY
                      </Text>

                      <Text style="h4" css={{ marginTop: '10px' }}>
                        {token?.token?.attributes?.find(
                          (attr) => attr.key === 'Affinity'
                        )?.value || 'N/A'}
                      </Text>

                      <Flex
                        css={{
                          width: '100%',
                          mb: '$3',
                          mt: '$2',
                          maxWidth: '200px',
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          css={{
                            width: '100%',
                            height: '8px',
                            position: 'relative',
                            overflow: 'hidden',
                            border: '1px solid gray',
                            marginRight: '10px',
                          }}
                        >
                          <Box
                            css={{
                              width: '100%',
                              height: '8px',
                              position: 'relative',
                              overflow: 'hidden',
                            }}
                          >
                            <Box
                              css={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                height: '100%',
                                backgroundColor: '#6e6e73',
                                width: `${parseFloat(
                                  token?.token?.attributes?.find(
                                    (attr) =>
                                      attr.key === '% Traits in Affinity'
                                  )?.value || '0'
                                )}%`,
                              }}
                            />
                          </Box>
                        </Box>
                        <Text
                          style="body3"
                          css={{
                            color: '#e0e0e0',
                            textAlign: 'right',
                            display: 'block',
                          }}
                        >
                          {token?.token?.attributes?.find(
                            (attr) => attr.key === '# Traits in Affinity'
                          )?.value || 'N/A'}
                          /
                          {token?.token?.attributes?.find(
                            (attr) => attr.key === '# Traits'
                          )?.value || 'N/A'}
                        </Text>
                      </Flex>
                    </Box>
                  )}
                  {/* Bio */}
                  {token?.token?.attributes?.some((attr) =>
                    ['Title', 'Name', 'Origin'].includes(attr.key)
                  ) && (
                    <Box
                      css={{
                        borderRadius: '$2',
                        padding: '$4',
                        border: '1px solid #3c3c3e',
                        flex: '1',
                        textAlign: 'center',
                        borderRadius: '8px',
                      }}
                    >
                      <Text
                        style="body3"
                        css={{
                          color: '#8e8e93',
                          display: 'block',
                          marginBottom: 10,
                        }}
                      >
                        BIO
                      </Text>
                      <Grid css={{ gap: '$2' }}>
                        {['Title', 'Name', 'Origin', 'Affiliation'].map(
                          (label) => {
                            const attribute = token?.token?.attributes?.find(
                              (attr) => attr.key === label
                            )
                            if (!attribute) return null
                            return (
                              <Flex
                                key={label}
                                justify="between"
                                align="center"
                              >
                                <Text css={{ color: '#8e8e93' }}>
                                  {label.toUpperCase()}
                                </Text>
                                <Text
                                  css={{
                                    color: '#e0e0e0',
                                    fontWeight: 'bold',
                                    fontFamily: '$header',
                                  }}
                                >
                                  {attribute.value}{' '}
                                  <Text
                                    css={{
                                      color: '#8e8e93',
                                      fontSize: '10px',
                                    }}
                                  >
                                    {attribute.tokenCount &&
                                      `${attribute.tokenCount} (`}
                                    {attribute.tokenCount &&
                                      (
                                        (attribute.tokenCount /
                                          collection?.tokenCount) *
                                        100
                                      ).toFixed(2)}
                                    {attribute.tokenCount && '%)'}
                                  </Text>
                                </Text>
                              </Flex>
                            )
                          }
                        )}
                      </Grid>
                    </Box>
                  )}

                  {/* Transmuted */}
                  {isTransmuted && (
                    <Box
                      css={{
                        borderRadius: '8px',
                        padding: '$4',
                        mb: '$4',
                        border: '1px solid #3c3c3e',
                        flex: '1',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '$4',
                      }}
                    >
                      {(() => {
                        const transmutedFromNumber =
                          token.token.attributes.find(
                            (attr) => attr.key === 'Transmuted from number'
                          )?.value
                        if (!transmutedFromNumber) return null

                        return (
                          <Link
                            href={`/ethereum/asset/0x521f9c7505005cfa19a8e5786a9c3c9c9f5e6f42:${transmutedFromNumber}`}
                            passHref
                          >
                            <Flex
                              direction="column"
                              css={{ cursor: 'pointer' }}
                            >
                              <Text style="subtitle1">
                                Transmuted from Wizard #{transmutedFromNumber}
                              </Text>
                              <Flex
                                align="center"
                                justify="center"
                                css={{ marginTop: '$2' }}
                              >
                                <img
                                  src={`https://www.forgottenrunes.com/api/art/wizards/${transmutedFromNumber}`}
                                  width={100}
                                  height={100}
                                  alt={`Wizard #${transmutedFromNumber}`}
                                />
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  height={16}
                                />
                                <img
                                  src={`https://www.forgottenrunes.com/api/art/souls/${transmutedFromNumber}`}
                                  width={100}
                                  height={100}
                                  alt={`Wizard #${transmutedFromNumber}`}
                                />
                              </Flex>
                            </Flex>
                          </Link>
                        )
                      })()}
                    </Box>
                  )}
                </Box>
              )
            )
          })()}
        </Flex>
        {/* Section 3: Tabs */}
        <Flex
          direction="column"
          css={{
            width: '100%',
          }}
        >
          <Tabs.Root
            value={tabValue}
            onValueChange={(value) => setTabValue(value)}
          >
            <TabsList
              css={{
                overflowX: isSmallDevice ? 'scroll' : 'unset',
              }}
            >
              <TabsTrigger value="lore">Lore</TabsTrigger>
              <TabsTrigger value="activity">Activity</TabsTrigger>
              <TabsTrigger value="listings">Listings</TabsTrigger>
              <TabsTrigger value="offers">Offers</TabsTrigger>
              <TabsTrigger value="info">Collection Info</TabsTrigger>
            </TabsList>

            <Box css={{ mt: '$4' }}>
              <TabsContent value="info">
                {collection && (
                  <TokenInfo token={token} collection={collection} />
                )}
              </TabsContent>

              <TabsContent value="activity">
                {isSmallDevice ? (
                  <MobileActivityFilters
                    activityTypes={activityTypes}
                    setActivityTypes={setActivityTypes}
                  />
                ) : (
                  <Dropdown
                    trigger={trigger}
                    contentProps={{
                      sideOffset: 8,
                    }}
                  >
                    <ActivityFilters
                      open={activityFiltersOpen}
                      setOpen={setActivityFiltersOpen}
                      activityTypes={activityTypes}
                      activityNames={activityNames}
                      setActivityNames={setActivityNames}
                      setActivityTypes={setActivityTypes}
                    />
                  </Dropdown>
                )}
                <TokenActivityTable
                  id={`${contract}:${token?.token?.tokenId}`}
                  activityTypes={activityTypes}
                />
              </TabsContent>

              <TabsContent value="listings">
                <ListingsTable
                  token={`${contract}:${token?.token?.tokenId}`}
                  address={account.address}
                  is1155={is1155}
                  isOwner={isOwner}
                />
              </TabsContent>

              <TabsContent value="offers">
                <OffersTable
                  token={`${contract}:${token?.token?.tokenId}`}
                  address={account.address}
                  is1155={is1155}
                  isOwner={isOwner}
                />
              </TabsContent>

              <TabsContent value="lore">
                <LoreTab token={token} />
              </TabsContent>
            </Box>
          </Tabs.Root>
        </Flex>
      </Flex>
    </Layout>
  )
}

type SSRProps = {
  collection?:
    | paths['/collections/v7']['get']['responses']['200']['schema']
    | null
  tokens?: paths['/tokens/v6']['get']['responses']['200']['schema'] | null
}

export const getServerSideProps: GetServerSideProps<{
  assetId?: string
  ssr: SSRProps
}> = async ({ params, res }) => {
  const assetId = params?.assetId ? params.assetId.toString().split(':') : []
  let collectionId = assetId[0]
  const id = assetId[1]
  const { reservoirBaseUrl } =
    supportedChains.find((chain) => params?.chain === chain.routePrefix) ||
    DefaultChain

  const contract = collectionId ? collectionId?.split(':')[0] : undefined

  const headers = {
    headers: {
      'x-api-key': process.env.RESERVOIR_API_KEY || '',
    },
  }

  let tokensQuery: paths['/tokens/v6']['get']['parameters']['query'] = {
    tokens: [`${contract}:${id}`],
    includeAttributes: true,
    includeTopBid: true,
    normalizeRoyalties: NORMALIZE_ROYALTIES,
    includeDynamicPricing: true,
  }

  let tokens: SSRProps['tokens'] = null
  let collection: SSRProps['collection'] = null

  try {
    const tokensPromise = fetcher(
      `${reservoirBaseUrl}/tokens/v6`,
      tokensQuery,
      headers
    )

    const tokensResponse = await tokensPromise
    tokens = tokensResponse.data
      ? (tokensResponse.data as Props['ssr']['tokens'])
      : {}

    let collectionQuery: paths['/collections/v7']['get']['parameters']['query'] =
      {
        id: tokens?.tokens?.[0]?.token?.collection?.id,
        normalizeRoyalties: NORMALIZE_ROYALTIES,
      }

    const collectionsPromise = fetcher(
      `${reservoirBaseUrl}/collections/v7`,
      collectionQuery,
      headers
    )

    const collectionsResponse = await collectionsPromise
    collection = collectionsResponse.data
      ? (collectionsResponse.data as Props['ssr']['collection'])
      : {}

    res.setHeader(
      'Cache-Control',
      'public, s-maxage=30, stale-while-revalidate=60'
    )
  } catch (e) {}

  return {
    props: {
      assetId: params?.assetId as string,
      ssr: { collection, tokens },
    },
  }
}

export default IndexPage
